import React from 'react';
import { Box, Link, Typography } from '@mui/material';

interface Props {
  onEnable: VoidFunction;
}

export const FinanceMenuDisabledState = ({ onEnable }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        py: 4,
        px: 2,
        backgroundColor: '#ECEFF180',
        borderRadius: 1,
      }}
    >
      <Typography variant="body1" fontWeight={500}>
        Finance & Menu is optional — press button to include
      </Typography>
      <Link component="button" variant="body2" onClick={onEnable} underline="none">
        ENABLE ADVANCED MENU BUILDER
      </Link>
    </Box>
  );
};
